import type {
  AppId,
  BackgroundJobId,
  CollectionId,
  ConversationId,
  DocumentId,
  DocumentVersionId,
  PackId,
} from "@superego/backend";

export enum RouteName {
  Ask = "Ask",
  Conversations = "Conversations",
  Conversation = "Conversation",
  CreateCollectionManual = "CreateCollection",
  CreateCollectionAssisted = "CreateCollectionAssisted",
  CreateNewCollectionVersion = "CreateNewCollectionVersion",
  Collection = "Collection",
  CollectionSettings = "CollectionSettings",
  CreateDocument = "CreateDocument",
  Document = "Document",
  EditApp = "EditApp",
  Boutique = "Boutique",
  Pack = "Pack",
  BackgroundJobs = "BackgroundJobs",
  BackgroundJob = "BackgroundJob",
  GlobalSettings = "Settings",
  NotFound = "NotFound",
}

export enum CollectionRouteView {
  Table = "Table",
  App = "App",
}

type Route =
  | {
      name: RouteName.Ask;
      initialMessage?: string;
    }
  | {
      name: RouteName.Conversations;
    }
  | {
      name: RouteName.Conversation;
      conversationId: ConversationId;
    }
  | {
      name: RouteName.CreateCollectionAssisted;
      initialMessage?: string;
    }
  | {
      name: RouteName.CreateCollectionManual;
    }
  | {
      name: RouteName.CreateNewCollectionVersion;
      collectionId: CollectionId;
    }
  | (
      | { name: RouteName.Collection; collectionId: CollectionId }
      | {
          name: RouteName.Collection;
          collectionId: CollectionId;
          view: CollectionRouteView.Table;
        }
      | {
          name: RouteName.Collection;
          collectionId: CollectionId;
          view: CollectionRouteView.App;
          appId: AppId;
        }
    )
  | {
      name: RouteName.CollectionSettings;
      collectionId: CollectionId;
    }
  | {
      name: RouteName.CreateDocument;
      collectionId: CollectionId;
    }
  | {
      name: RouteName.Document;
      collectionId: CollectionId;
      documentId: DocumentId;
      documentVersionId?: DocumentVersionId;
      redirectIfLatest?: boolean;
    }
  | {
      name: RouteName.EditApp;
      appId: AppId;
    }
  | {
      name: RouteName.Boutique;
    }
  | {
      name: RouteName.Pack;
      packId: PackId;
    }
  | {
      name: RouteName.BackgroundJobs;
    }
  | {
      name: RouteName.BackgroundJob;
      backgroundJobId: BackgroundJobId;
    }
  | {
      name: RouteName.GlobalSettings;
    }
  | {
      name: RouteName.NotFound;
      route: string;
    };

export default Route;
